import { render, staticRenderFns } from "./BusinessMemberView.vue?vue&type=template&id=33831542"
import script from "./BusinessMemberView.vue?vue&type=script&lang=js"
export * from "./BusinessMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports